/**
 * 展示文案。**枚举一律从 `@usales/contract` 派生,前端不另造一份。**
 *
 * 这不是洁癖:原来 Customers.tsx 里手抄了一份阶段映射,写的是
 * `contacted / need_confirmed / lost` —— 而契约里是
 * `first_contact / needs_confirmed / closing`,于是列表里那些客户的阶段
 * 一直显示成原始英文值,没人发现,因为它看起来"像个阶段"。
 * 枚举有唯一定义处这条规矩,防的就是这种没人会注意到的漂移。
 */
export {
  CUSTOMER_STAGES, CUSTOMER_STAGE_LABEL, stageIndex,
  CUSTOMER_SOURCE_LABEL, ARTIFACT_SOURCE_TYPE_LABEL,
  EVENT_SIGNAL_KIND_LABEL, KNOWLEDGE_PARTITION_LABEL,
  AUTONOMY_LEVEL_LABEL,
} from "@usales/contract/values";
// 下面 srcChip 要用它的值,re-export 不绑定本地名,得单独 import
import { CUSTOMER_SOURCE_LABEL } from "@usales/contract/values";
import type { CustomerSource } from "@usales/contract/values";
// 自主度在前端只当数字用(徽标显示 L2/L3),不需要把 zod 的联合类型搬过来
export type { CustomerStage } from "@usales/contract/values";

/**
 * 来源小 chip。列表列宽只够放一个图标,全称进 title —— 契约里的原文
 * 是「🤖 AI分配」这种「图标+文字」,前两个 UTF-16 码元正好是图标本身
 * (🤖 是代理对、✏️ 是 U+270F+FE0F,都是 2 码元)。
 */
const SRC_CHIP_CLASS: Record<string, string> = {
  ai_assigned: "src-ai", manager_assigned: "src-mgr", peer_handoff: "src-peer",
  self_created: "src-self", bulk_import: "src-import",
};

export const srcChip = (source: string): { cls: string; icon: string; label: string } => {
  const label = CUSTOMER_SOURCE_LABEL[source as CustomerSource] ?? source;
  return { cls: SRC_CHIP_CLASS[source] ?? "src-self", icon: label.slice(0, 2), label };
};

/** 动作渠道的图标,来自原型的动作卡。 */
export const CHANNEL_LABEL: Record<string, string> = {
  call: "📞 电话", email: "📧 发送", visit: "🚗 拜访",
  meeting: "🤝 会议", prep: "📋 准备",
};

/** 决策链角色下拉,与原型 CONTACT_ROLES 一致。 */
export const CONTACT_ROLES = ["技术把关", "拍板决策", "采购执行", "使用部门", "财务审批"] as const;

/** 自主度徽标的样式。L2 待确认是琥珀色,L3 先斩后奏是灰底 —— 原型里的两档。 */
export const levelPill = (level: number): string =>
  level >= 3 ? "pill-l3" : "pill-l2";

export const fmtDate = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleDateString("zh-CN", { month: "2-digit", day: "2-digit" }) : "—";

export const fmtDateTime = (iso: string | null | undefined): string =>
  iso ? new Date(iso).toLocaleString("zh-CN", { month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—";

export const fmtMoney = (v: string | number | null | undefined): string => {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (!Number.isFinite(n)) return String(v);
  return n >= 10000 ? `${(n / 10000).toFixed(n % 10000 === 0 ? 0 : 1)} 万` : `${n} 元`;
};
